import { createContext, useContext } from 'react'

import { GlobalModal } from '@editor/interfaces/interfaces'

const initialState: GlobalModal = {
  showModal: () => null,
  showErrorModal: () => null,
  updateModal: () => null,
  hideModal: () => null,
}

export const GlobalModalContext = createContext(initialState)
export const useGlobalModalContext = () => useContext(GlobalModalContext)
